const endpoints = {
  createPolicy: (): string => `policy`,
  updatePolicy: (id: string): string => `policy/${id}`,
};

export default endpoints;
